import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMasters } from "../../api";
import { useNavigate } from "react-router-dom";
import { changeSelectedMaster } from "../../store/slice/orderSlice";
import { convertPrice, getTimeFromMins } from "../../config";

const MastersList = () => {
  const { selectedStudio, selectedMaster, selectedService } = useSelector((state) => state.orderReducer);
  const dispatch = useDispatch();
  const [masters, setMasters] = useState({
    top: [],
    master: [],
    junior: [],
    none: [],
  });

  const [filter, setFilter] = useState("all");

  const redirect = useNavigate();

  useEffect(() => {
    selectedStudio && getStudioMasters(selectedStudio.id);
  }, []);

  const getStudioMasters = async (studioId) => {
    const masters = await getMasters(studioId);
    const filteredMastersByRank = {
      top: [],
      master: [],
      junior: [],
      none: [],
    };

    masters.data.forEach((master) => {
      const result = master.skills.find((skill) => skill.service?.id === selectedService?.id);

      if (result) {
        filteredMastersByRank[result.rank]?.push(master);
      }
    });

    setMasters(filteredMastersByRank);
  };

  const selectMaster = (master, rank) => {
    return () => {
      dispatch(
        changeSelectedMaster({
          ...master,
          rank: rank,
        })
      );
      redirect("/booking/date");
    };
  };

  return (
    <div className="masters-list">
      <div className="masters-list__header">
        Master Lever
        <div className="filter">
          <button className={filter === "all" ? "filter-btn active" : "filter-btn"} onClick={() => setFilter("all")}>
            All
          </button>
          <button className={filter === "top" ? "filter-btn active" : "filter-btn"} onClick={() => setFilter("top")}>
            Top
          </button>
          <button
            className={filter === "master" ? "filter-btn active" : "filter-btn"}
            onClick={() => setFilter("master")}
          >
            Master
          </button>
          <button
            className={filter === "junior" ? "filter-btn active" : "filter-btn"}
            onClick={() => setFilter("junior")}
          >
            Junior
          </button>
          <button className={filter === "none" ? "filter-btn active" : "filter-btn"} onClick={() => setFilter("none")}>
            Non-Level
          </button>
        </div>
      </div>
      <div className="masters-list__body">
        {!!masters.top.length && (filter === "all" || filter === "top") && (
          <div className="list-level__wrapper">
            <div className="list-level__title">Top</div>
            <div className="list-level">
              {masters.top.map((master) => (
                <Master master={master} lvl={"top"} selectedService={selectedService} selectMaster={selectMaster} />
              ))}
            </div>
          </div>
        )}

        {!!masters.master.length && (filter === "all" || filter === "master") && (
          <div className="list-level__wrapper">
            <div className="list-level__title">Master</div>
            <div className="list-level">
              {masters.master.map((master) => (
                <Master master={master} lvl={"master"} selectedService={selectedService} selectMaster={selectMaster} />
              ))}
            </div>
          </div>
        )}

        {!!masters.junior.length && (filter === "all" || filter === "junior") && (
          <div className="list-level__wrapper">
            <div className="list-level__title">Junior</div>
            <div className="list-level">
              {masters.junior.map((master) => (
                <Master master={master} lvl={"junior"} selectedService={selectedService} selectMaster={selectMaster} />
              ))}
            </div>
          </div>
        )}

        {!!masters.none.length && (filter === "all" || filter === "none") && (
          <div className="list-level__wrapper">
            <div className="list-level__title">Non-Level</div>
            <div className="list-level">
              {masters.none.map((master) => (
                <Master master={master} lvl={"none"} selectedService={selectedService} selectMaster={selectMaster} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Master = ({ master, lvl, selectedService, selectMaster }) => {
  const serviceData = master.skills.find(skill => skill.service?.id === selectedService.id).service;
  const price = serviceData.priceList.find((price) => price.rank === lvl)?.price;

  return (
    <div className="master" key={master.id}>
      <div className="photo">
        <img src={master.img} alt="Photo masters" />
      </div>
      <div className="info">
        <div className="name">
          {master.firstName} {master.lastName}
        </div>
        <div className="services">{selectedService.title}</div>
        <div className="cost-and-duration">
          {serviceData.priceList?.length && (
            <>
              <div className="cost">{convertPrice(price)} €</div>
              <div className="point"></div>
            </>
          )}
          <div className="duration">{getTimeFromMins(serviceData.duration)} h.</div>
        </div>
      </div>
      <div className="select">
        <button onClick={selectMaster(master, lvl)} className="select-btn">
          Select +
        </button>
      </div>
    </div>
  );
};

export default MastersList;
